import { differenceInCalendarDays, isValid, parseDateOnly } from 'lib/helpers/dateUtils';
import { cn } from 'lib/helpers/utility';

import Avatar from 'components/shared/Avatar/Avatar';
import Button from 'components/shared/Button/Button';
import Icon from 'components/shared/Icon/Icon';

const TaskOverviewCard = ({ task, navigateToTask }) => {
  const assignment = task?.assignments?.[0]; //Getting first assignment because we filtered tasks by current user
  const assignedByFullName = `${assignment?.assigned_by_first_name || ''} ${
    assignment?.assigned_by_last_name || ''
  }`.trim();

  // Strip any time portion and parse as a local date-only value so the day
  // count doesn't shift across viewer timezones (a UTC ISO due_date would
  // otherwise resolve to the previous day for viewers west of UTC).
  const parsedDueDate = assignment?.due_date
    ? parseDateOnly(String(assignment.due_date).split('T')[0])
    : null;
  const daysUntilDue =
    parsedDueDate && isValid(parsedDueDate)
      ? differenceInCalendarDays(parsedDueDate, new Date())
      : null;

  const isOverdue = daysUntilDue !== null && daysUntilDue < 0;
  const isDanger = !isOverdue && daysUntilDue !== null && daysUntilDue <= 7;
  const isWarning = !isOverdue && daysUntilDue !== null && daysUntilDue > 7 && daysUntilDue <= 14;

  return (
    <div className="task-overview-card w-full min-w-[600px] rounded-xl bg-white px-4 py-3">
      <div className="mb-3 flex w-full items-center justify-between">
        <div>
          <div className="font-500 text-primary-900">
            {task?.step_name
              ? `Step: ${task?.step_name}`
              : task?.substep_name
                ? `Substep: ${task.substep_name}`
                : ''}
          </div>
        </div>
        <div className="flex items-center justify-center gap-2 text-sm text-neutral-600">
          <div
            className={cn(
              'flex items-center gap-1',
              (isOverdue || isDanger) && 'text-danger-500',
              isWarning && 'text-warning-500'
            )}>
            {daysUntilDue === null ? (
              'No due date'
            ) : isOverdue ? (
              'Due date passed'
            ) : (
              <>
                <Icon
                  color={isDanger ? 'danger' : isWarning ? 'warning' : 'neutral'}
                  shade={600}
                  icon="timer-linear"
                />
                Due in {daysUntilDue} days
              </>
            )}
          </div>
        </div>
      </div>
      <p className="mb-6 max-h-12 overflow-y-auto text-left text-sm text-neutral-600">
        {assignment?.note}
      </p>
      <div className="flex items-center justify-between border-b-0 border-l-0 border-r-0 border-t border-solid border-neutral-100 pt-3">
        <div className="flex items-center justify-center gap-2">
          Delegated By
          <div className="flex items-center gap-2 rounded-3xl border border-solid border-neutral-300 p-2">
            <Avatar fullName={assignedByFullName} />
            {assignedByFullName}
          </div>
        </div>
        <div>
          <Button
            text="Review"
            onClick={() =>
              navigateToTask({ substepCode: task?.substep_code, stepCode: task?.step_code })
            }
          />
        </div>
      </div>
    </div>
  );
};
export default TaskOverviewCard;
